import { useMemo } from "react";
import { MIN_PROJECT_DATE } from "@/constants";

export interface UseYearRangeResult {
  years: number[];
  minYear: number;
  maxYear: number;
}

export const useYearRange = (
  startYearOffset = 0,
  endYearOffset = 0,
): UseYearRangeResult =>
  useMemo(() => {
    const minProjectYear = MIN_PROJECT_DATE.getFullYear();
    const currentYear = new Date().getFullYear();
    const start =
      startYearOffset > 0
        ? Math.max(minProjectYear, currentYear - startYearOffset)
        : currentYear;
    const end = currentYear + endYearOffset;
    const length = end - start + 1;
    const years = Array.from({ length }, (_, i) => start + i);
    return {
      years,
      minYear: start,
      maxYear: end,
    };
  }, [startYearOffset, endYearOffset]);
